/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import * as Yup from 'yup';

import {
  Avatar,
  Box,
  Container,
  List,
  ListSubheader,
  ListItem,
  Stack,
  useMediaQuery,
} from '@mui/material';

import { ItemText } from '../../components/itemText';
import TextField from '../../components/textfield';
import { Header } from '../../components/layout/header';
import { Middle } from '../../components/layout/middle';
import { Carrousel } from '../../components/layout/carrousel';
import { CarrouselClientes } from '../../components/layout/carrouselClientes';
import { Contato } from '../../components/layout/contato';
import { Footer } from '../../components/layout/footer';
import Responsive from '../../components/layout/middle/Responsive';
import { BaseDiv } from './styles';



const Home: React.FC = () => {
  const navigate = useNavigate();
  let location = useLocation();
  const contatoRef = React.useRef<HTMLDivElement>(null);
  const ref: any = React.useRef(null);
  const refmid = React.useRef(null);
  const [dadosRef, setDadosRef] = React.useState(null);
  const [refTitle, setRefTitle] = React.useState(null);

  const matches = useMediaQuery('(max-width:800px)');
  const matches2 = useMediaQuery('(max-width:1100px)');

  React.useEffect(() => {
    // Função para lidar com o redimensionamento da página
    const handleResize = () => {
      setDadosRef(ref.current);
      setRefTitle(ref?.current?.title)
      // Adicione qualquer outra lógica que você deseja executar quando a página for redimensionada
    };

    // Adiciona um ouvinte de evento de redimensionamento
    window.addEventListener('resize', handleResize);

    // Chama a função de manipulação de redimensionamento quando o componente é montado
    handleResize();

    // Remove o ouvinte de evento quando o componente é desmontado
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [dadosRef, ref]);

  return (
    <BaseDiv>
      <Box>
          <Box>
            <Header reference={dadosRef} title={refTitle}/>
            <div ref={refmid}>
              <Middle/>
            </div>
          </Box>
          <Box>
            <Footer />
          </Box>
        </Box>
    </BaseDiv>
  );
}

export { Home }